<template>
  <!-- 我的考试 -->
  <div class="quesTion">
    <kind-choose-view :showKc="true" :type="7" @isOk="isOk" />
    <div class="qustionList">
      <!-- 试卷包 -->
      <div class="car-two" v-if="list && list.length > 0 && search.examType == 1">
        <div class="item" v-for="(item, index) in list" :key="index">
          <div class="item-content">
            <img class="item-img" src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/study/pagerBank.png" />
            <div class="item-title">
              <div class="item-text twoEllipsis">{{ item.name }}</div>
              <div class="item-tips elp">
                共{{ item.paperNum ? item.paperNum : 0 }}套试卷
              </div>
            </div>
          </div>
          <div class="item-but">
            <div class="elp have" v-if="item.isPay">已购买</div>
            <div class="elp price" v-else>
              <span class="price-icon">￥</span>{{ item.price }}
            </div>
            <div class="keep-learn keep-check" @click="goPage(item)">
              查看试卷
            </div>
          </div>
        </div>
      </div>
      <!-- 试卷  -->
      <div class="car-two" v-if="list && list.length > 0 && search.examType == 2">
        <div class="item" v-for="(item, index) in list" :key="index">
          <div class="item-content">
            <img v-if="item.typeId == '62'" class="item-imgV"
              src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/study/tati.png" />
            <img v-else class="item-imgV" src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/study/pager.png" />
            <div class="item-title">
              <div class="item-text twoEllipsis">{{ item.name }}</div>
              <div v-if="item.typeName" class="item-tips">【{{ item.typeName }}】</div>
            </div>
          </div>
          <div class="item-but">

            <!-- <div class="elp have" v-if="item.status == 1">已购买</div> -->
            <div class="elp price">
              <span class="price-icon">￥</span>{{ item.price }}
            </div>

            <div v-if="item.isPay ==0">
              <div class="keep-learn keep-check" v-if="!item.trySee" @click="goOrder(12, item)">
                立即购买
              </div>
              <div v-else class="keep-learn" @click="goLearn(item, false)">
                免费试看
              </div>
            </div>
            <div v-else class="keep-learn" @click="goLearn(item, true)">
              马上做题
            </div>
          </div>
        </div>
      </div>
      <!-- 暂无课程 -->
      <div class="nothing" v-if="!list || list.length == 0">
        <div class="nothing-text">暂无内容哦~</div>
      </div>
      <el-pagination class="pagination" :total="total" :current-page="pageNum" :page-sizes="[9, 15, 21, 27]"
        :page-size="pageSize" :pager-count="5" @current-change="handleCurrentChange" @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import { getInfo, getToken } from '@/api/cookies'
import KindChooseView from '@/components/kindChooseViewtk.vue'
// import { OrderClient } from '@/api/orderClient'
// let orderClient = new OrderClient()
// import { AnswerClient } from '@/api/task/answerClient'
// let answerClient = new AnswerClient()
import { HomeClient } from "@/api/home";
const homeClient = new HomeClient();
export default {
  components: {
    KindChooseView
  },

  data() {
    return {
      list: [], //查询列表
      getInfo: null,
      search: {
        examType: 1
      },
      pageSize: 9,
      pageNum: 1,
      total: 0,

      /* 考点讲解显示 */
      ifPlace: false,
      thisList: null,

      testPaperType: null
    }
  },
  async created() {
    this.testPaperType = this.$route.query.type
    this.userInfo = getInfo()
    this.getList();
  },
  methods: {
    /* 获取列表 */
    getList() {
      const loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: '',
        background: 'rgba(0, 0, 0, 0.2)'
      })
      console.log(this.search.examType);

      if (this.search.examType == 1) {
        /* 试卷包 */
        homeClient
          .getPaperPackageList(
            {
              pageNum: this.pageNum,
              pageSize: this.pageSize,
              belongProject: this.search.kind ? this.search.kind : undefined,
              belongMajor: this.search.zyId ? this.search.zyId : undefined,
              belongCourseTitle: this.search.kcId ? this.search.kcId : undefined,
              name: this.search.name ? this.search.name : undefined,
              classification: this.search.type ? this.search.type : undefined
            }
          )
          .then((res) => {

            this.list = res.data.rows || []
            this.total = res.data.total

            loading.close()
          })
      } else {
        /* 试卷 */
        homeClient
          .getNewList(
            {
              pageNum: this.pageNum,
              pageSize: this.pageSize,
              belongProject: this.search.kind ? this.search.kind : undefined,
              belongMajor: this.search.zyId ? this.search.zyId : undefined,
              belongCourseTitle: this.search.kcId ? this.search.kcId : undefined,
              name: this.search.name ? this.search.name : undefined,
              type: this.search.type ? this.search.type : undefined
            }
          )
          .then((res) => {

            this.list = res.data.rows || []
            this.total = res.data.total

            loading.close()
          })
      }

    },

    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getList()
    },
    /* --------------------搜索--------------------------------- */
    // 筛选
    isOk(val) {
      this.search = val

      this.searchClick()
    },
    /* 搜索 */
    searchClick() {
      this.pageNum = 1
      this.list = []
      this.total = 0
      this.getList()
    },
    /* --------------------购买--------------------------------- */

    // 立即购买
    goOrder(type, item) {
      const token = getToken()
            if (token) {
              let arr = [];
              let obj = {
                commodityTypeCode: 28,
                commodityId: item.id,
                discount: 0,
              };
              arr.push(obj);
              homeClient
                .addPayOrders(arr, undefined)
                .then((res) => {
                  if (res.code == 0) {
                    this.$router.push(`/orders/${res.data.orderNum}`)
                  } else {
                    this.$message.error(res.msg)
                  }
                })
            } else {
              Vue.prototype.goLoginView(true);
            }
    },
    /* 试卷bao做题 */
    goPage(item) {
      if (!this.userInfo) {
        this.$notify({
          title: '错误',
          message: '未登录，无法做题, 请先去登录',
          type: 'error',
          duration: 2000
        })
        return
      }
      this.$router.push(`/all/examPack?packId=${item.id}`)
    },
    /* 试卷做题 */
    /* 做题 */
    goLearn(item,) {

      // homeClient.whetherBuy({
      //   commodityId: item.id,
      //   commodityTypeCode: 4,
      // }).then((res) => {
      //   if (res.code == 0) {
      //     // this.IsPurchase = res.data == 1 ? true : false
      //     if (res.data == 1) {
            Vue.prototype.goExam({ contactId: item.id, examType: 12 })
      //     } else {
           
      //     }
      //   }
      // })


    },
    /* 进入考点*/
    goPlace(item) {
      if (!this.userInfo) {
        Vue.prototype.goLoginView
        return
      }
    }
  }
}
</script>
<style lang="less" scoped>
/deep/.btn-quicknext {
  width: 40px;
  height: 40px;
}
</style>
